<template>
  <nav-bar title="检查历史" />
  <Content :bottom="0">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.crId" @click="$router.push(`/inspectionResults/${item.crId}`)">
        <div class="list-item__name">{{item.crUserComName}}</div>
        <div class="list-item__type">
          <span>检查类型：</span>
          <span>{{item.ctypeName}}</span>
        </div>
        <div class="list-item__time">
          <span>检查时间：</span>
          <span>{{item.crChecktime}}</span>
        </div>
      </li>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="getList"
    />
  </Content>
</template>

<script>

import { useLoadingMore } from '@/hooks/useLoadingMore'
import { queryCheckResultListByDoUserId, queryCheckResultListByUserId } from '@/api/user'
import { useStore } from 'vuex'
import { computed } from 'vue'
export default {
  name: 'CheckHistory',
  setup () {
    const store = useStore()
    const roleId = computed(() => store.state.roleInfo.roleId)
    const userId = computed(() => store.state.userInfo.id)
    const method = roleId.value === 'c' ? queryCheckResultListByUserId : queryCheckResultListByDoUserId
    const data = useLoadingMore(method)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.userId = userId.value
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init()
    return { getList, list, finished, loadingFail, pageParams, ...data }
  }
}
</script>

<style lang="scss" scoped>
.list {
    padding: 16px 16px 0 16px;
    .list-item {
      padding: 10px 16px;
      font-size: 16px;
      background-color: #fff;
      box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
      margin-bottom: 16px;
      color: #666;
      line-height: 24px;
      &__name {
        font-weight: 600;
        color: #333;
        font-size: 14px;
      }
      span {
        margin-right: 5px;
        font-size: 12px;
      }
    }
}
</style>
